import { render, staticRenderFns } from "./TenantList.vue?vue&type=template&id=23c485be&scoped=true&"
import script from "./TenantList.vue?vue&type=script&lang=js&"
export * from "./TenantList.vue?vue&type=script&lang=js&"
import style0 from "./TenantList.vue?vue&type=style&index=0&id=23c485be&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c485be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23c485be')) {
      api.createRecord('23c485be', component.options)
    } else {
      api.reload('23c485be', component.options)
    }
    module.hot.accept("./TenantList.vue?vue&type=template&id=23c485be&scoped=true&", function () {
      api.rerender('23c485be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/TenantList.vue"
export default component.exports